import { render, staticRenderFns } from "./FragmentDelfiShort.vue?vue&type=template&id=f715beb4&scoped=true"
import script from "./FragmentDelfiShort.vue?vue&type=script&lang=ts"
export * from "./FragmentDelfiShort.vue?vue&type=script&lang=ts"
import style0 from "./FragmentDelfiShort.vue?vue&type=style&index=0&id=f715beb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f715beb4",
  null
  
)

export default component.exports